export default {
  computed: {
    nombre: {
      get() {
        return this.$store.state.clientes.ModificarCliente.nombre;
      },
      set(val) {
        return this.$store.commit("clientes/ModificarCliente/setNombre", val);
      },
    },
    apellido: {
      get() {
        return this.$store.state.clientes.ModificarCliente.apellido;
      },
      set(val) {
        return this.$store.commit("clientes/ModificarCliente/setApellido", val);
      },
    },
    nombreWeb: {
      get() {
        return this.$store.state.clientes.ModificarCliente.nombreWeb;
      },
      set(val) {
        return this.$store.commit(
          "clientes/ModificarCliente/setNombreWeb",
          val,
        );
      },
    },
    telCelular: {
      get() {
        return this.$store.state.clientes.ModificarCliente.telCelular;
      },
      set(val) {
        return this.$store.commit(
          "clientes/ModificarCliente/setTelCelular",
          val,
        );
      },
    },
    emailFacturacion: {
      get() {
        return this.$store.state.clientes.ModificarCliente.emailFacturacion;
      },
      set(val) {
        return this.$store.commit(
          "clientes/ModificarCliente/setEmailFacturacion",
          val,
        );
      },
    },
    emailGerencia: {
      get() {
        return this.$store.state.clientes.ModificarCliente.emailGerencia;
      },
      set(val) {
        return this.$store.commit(
          "clientes/ModificarCliente/setEmailGerencia",
          val,
        );
      },
    },
    usuario: {
      get() {
        return this.$store.state.clientes.ModificarCliente.nombreUsuario;
      },
      set(val) {
        return this.$store.commit(
          "clientes/ModificarCliente/setNombreUsuario",
          val,
        );
      },
    },
    password: {
      get() {
        return this.$store.state.clientes.ModificarCliente.password;
      },
      set(val) {
        return this.$store.commit("clientes/ModificarCliente/setPassword", val);
      },
    },
    cobranzas: {
      get() {
        return this.$store.state.clientes.ModificarCliente.cobranzas;
      },
      set(val) {
        return this.$store.commit(
          "clientes/ModificarCliente/setCobranzas",
          val,
        );
      },
    },
  },
};
